export function feedbackerFeedbackCount(feedback) {
    return feedback?.user?.contact_feedbacks_at_business_count ?? 0;
}
